import React from 'react';
// import Chartist from 'chartist';
// import ChartistGraph from 'react-chartist';
import { PieChart } from 'react-minimal-pie-chart';
import './piechart.scss';

export const DonutChart = ({
  percent,
  id,
  radius = 50,
  startAngle = -90,
  lineWidth = 15,
  size = '25px',
  lineColor = '00B277',
  type = 'single',
  data = [],
}) => (
  <div className="position-relative">
    <PieChart
        lineWidth={lineWidth}
        startAngle={startAngle}
        totalValue={100}
        radius={radius}
        label={({ dataEntry }) => `${(dataEntry.percentage)}%`}
        data={data}
        // rounded={type != 'single'}
        // data={[
        //   { title: `${percent}%`, value: percent, color: percent == 100 ? '#00B277' : '#E55051' },
        //   // { title: '', value: 100 - percent, color: '#EEEEEE' },
        // ]}
        labelStyle={{
          fontSize: size,
          fontFamily: 'sans-serif',
          // fill: '#00b277',
          // fill: type == 'single' ? percent == 100 ? '#00B277' : '#E55051' : 'transparent',
          fill: 'transparent',
        }}
        labelPosition={0} />
    {type == 'single' && (
    <div className="percentage font-monsterArt">
      <span className="fs-10" style={percent >= 100 ? { color: '#00b277' } : { color: '#E55051' }}>
        {percent < 100 ? percent : 100}
        %
      </span>
    </div>
    )}
  </div>
);
export default DonutChart;
